import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgJourneyBarSeperator = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 26,
	viewBox: "0 0 20 39",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 0L19 19.5L1 39",
		stroke: "#DEDEDE",
		strokeWidth: 2
	})
});
export default SvgJourneyBarSeperator;
